"use client";

import React from "react";
import { Provider } from "react-redux";
import { getStore } from "./store";

// Deliberately not using redux-persist's <PersistGate> here: PersistGate
// blocks rendering of children until rehydration from localStorage
// completes, which is client-only. On the server (no localStorage), it
// never resolves, so it was rendering `loading={null}` for every
// server-rendered page, sitewide — no page ever shipped real HTML.
// persistStore() (in ./store) already runs rehydration in the background
// regardless of PersistGate, so removing it here only removes the render
// block, not persistence itself.
export function ReduxProvider({
  children,
  preloadedState,
}: {
  children: React.ReactNode;
  preloadedState?: any;
}) {
  const store = getStore(preloadedState);

  return (
    <Provider store={store}>
      {children}
    </Provider>
  );
}
